export const OrderFields = {
  PO_REF: "poRef",
  CUSTOMER_PO_REF: "customerPoRef",
  CUSTOMER: "customer",
  CUSTOMER_ID: "customerId",
  SEASON: "season",
  SEASON_ID: "seasonId",
  MERCHANT: "merchant",
  TOTAL_QTY: "totalQty",
  PRODUCTS: "products",
  STYLES: "styles",
  ORDER_QTY: "orderQty",
  LINES: "lines",
  STATE: "state",
  DESCRIPTION: "desc",
  CUSTOM_FIELD_1: "customField1",
  CUSTOM_FIELD_2: "customField2",
  CUSTOM_FIELD_3: "customField3"
};

export const FabricFields = {
  ITEM_CODE: "itemCode",
  ITEM_DESCRIPTION: "itemDesc",
  ARTICLE_NAME: "articleName",
  CLASSIFICATION: "classification",
  FABRIC_CATEGORY: "fabricCategory",
  FABRIC_CATEGORY_ID: "fabricCategoryId",
  FABRIC_PATTERN: "fabricPattern",
  FABRIC_PATTERN_ID: "fabricPatternId",
  SUPPLIER_LIST: "supplierList",
  SUPPLIER_IDS: "supplierIds",
  CONSTRUCTION: "construction",
  CONTENT: "content",
  REPEAT_LENGTH: "repeatLength",
  REPEAT_WIDTH: "repeatWidth",
  WIDTH: "width",
  GSM: "gsm",
  WARP_SHRINKAGE: "warpShrinkage",
  WEFT_SHRINKAGE: "weftShrinkage",
  CUSTOM_FIELD_1: "customField1",
  CUSTOM_FIELD_2: "customField2",
  CUSTOM_FIELD_3: "customField3",
  REMARKS: "Description"
};

export const CustomerFields = {
  NAME: "name",
  CODE: "code",
  CURR_CODE: "currCode",
  CURR_NAME: "currName",
  DESCRIPTION: "desc",
  CUSTOM_FIELD_1: "customField1",
  CUSTOM_FIELD_2: "customField2",
  CUSTOM_FIELD_3: "customField3"
};

export const SeasonFields = {
  NAME: "name",
  DESCRIPTION: "desc"
};

export const FlowInfoFields = {
  ID: "id",
  FLOW_REF: "flowRef",
  DEL_FLOW_REF: "delFlowRef",
  PRIMARY_UNIT_ID: "primaryUnitId",
  CUSTOMER_FLOW_REF: "customerFlowRef",
  FPO: "fpo",
  PRODUCT: "product",
  PRODUCT_ID: "productId",
  PRODUCT_NAME: "productName",
  RATIO: "ratio",
  GROUP_DESTINATION: "groupDestination",
  STYLE_NO: "styleNo",
  STYLE: "style",
  STYLE_IMAGE: "styleImage",
  FIT: "fit",
  COLOR: "color",
  INSEAM: "inseam",
  ORDER_QTY: "orderQty",
  FPO_QTY: "fpoQty",
  EXTRA: "extra",
  SHORT_SHIP: "shortShipPercent",
  DESTINATION: "destination",
  EX_FACTORY_DATE: "exFactoryDate",
  DELIVERY_DATE: "deliveryDate",
  DEL_MODE: "delMode",
  GENDER: "gender",
  SLEEVE_TYPE: "sleeveType",
  CUSTOM_FIELD_1: "customField1",
  CUSTOM_FIELD_2: "customField2",
  CUSTOM_FIELD_3: "customField3",
  STATE: "state",
  STATUS: "status"
};

export const OrderFlowFields = {
  state: "state"
};

export const UserFields = {
  FULL_NAME: "fullName",
  USER_NAME: "username",
  EMAIL: "email",
  MOBILE: "mobile",
  ROLES: "roles",
  CUSTOM_FIELD_1: "customField1",
  CUSTOM_FIELD_2: "customField2",
  CUSTOM_FIELD_3: "customField3"
};

export const WarehousFields = {
  NAME: "name",
  CODE: "code",
  UNIT_ID: "unitId",
  DESC: "desc"
};

export const UsersFields = {
  FULL_NAME: "fullName",
  USER_NAME: "username",
  EMAIL: "email",
  MOBILE: "mobile",
  ROLES: "roles",
  CUSTOMER: "customerIds",
  WAREHOUSES: "warehouseIds"
};

export const TableFields = {
  NAME: "name",
  DESC: "desc",
  ENABLED: "enabled"
};

export const UnitFields = {
  NAME: "name",
  UNIT_ID: "unitId",
  REGION: "region",
  DESC: "desc"
};

export const SeasonsFields = {
  NAME: "name",
  DESC: "desc"
};

export const SupplierFields = {
  NAME: "name",
  DESC: "desc"
};

export const ProductFields = {
  NAME: "name",
  BUNDLE_PARTS: "bundleParts",
  REPLACEMENT_PANELS: "replacementPanels",
  SERIAL_RESET_AT: "serialResetAt",
  BUNDLE_RESET_AT: "bundleResetAt",
  BUNDLE_BREAK_AT: "bundleBreakAt",
  BUNDLE_SIZE_SORT: "bundleSizeSort",
  BUNDLE_SERIAL_SORT: "bundleSerialSort",
  max_BOM_CU: "maxBomCu",
  DESC: "desc"
};

export const AlertParameterFields = {
  PARAMETER: "parameter",
  MINUS_TOLERANCE: "minusTolerance",
  PLUS_TOLERANCE: "plusTolerance",
  TOLERANCE_UNIT: "toleranceUnit",
  DESC: "desc"
};

export const fabricPatternFields = {
  NAME: "name",
  DESC: "desc"
};

export const fabricCategoryFields = {
  NAME: "name",
  DESC: "desc"
};

export const DepartmentFields = {
  NAME: "name",
  DESC: "desc"
};

export const CustomersFields = {
  NAME: "name",
  CODE: "code",
  DESC: "desc"
};
